import { render, staticRenderFns } from "./AddDriver.vue?vue&type=template&id=7a498524&lang=pug&"
import script from "./AddDriver.vue?vue&type=script&lang=ts&"
export * from "./AddDriver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports